import { MachineSensorManager } from './states'


export enum MACHINE_STATUS {
  OFF = 'OFF',
  ON = 'ON',
  USE = 'USE',
  PRACTICE = 'PRACTICE',
  END = 'END',
}

type BayMachineBase = {
  calibrationDate: string
  gridX: number
  gridY: number
  hardwareID: number
  hardwareName: string
  loginCode?: number
  macAddress: string | number | null
  machineID: number
  name: string
  nation: string
  private: 0 | 1
  serialNumber: string
  shopID: number
  shopName: string
  timezone: string
  status?: MACHINE_STATUS
  smartLoginState: 0 | 1
}

type BayMachineOnAttributes = {
  ip: string
  sensorState: string
  sensorManager: MachineSensorManager
  serverKey: string
  shopType: number
  socketID: string
}

type BayMachineUseAttributes = {
  shopMemberID: number | string
  userID: number | string
  userItemName: string
  userName: string
  userNickName: string
  startDate?: string
  endDate?: string
  timer?: {
    remainTime: number
    remainTimePercent: number
  }
}

export type BayMachineOff = BayMachineBase
export type BayMachineOn = BayMachineBase & BayMachineOnAttributes
export type BayMachineUse = BayMachineOn & BayMachineUseAttributes
export type BayMachine = BayMachineBase &
Partial<BayMachineOnAttributes> &
Partial<BayMachineUseAttributes>

export type RawBayMachineList = { [key: number]: BayMachine }
export type BayMachineList = BayMachine[]
